import API from 'utils/api';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'recaudacion/autoridades-determinantes-pae/';

/**
 * GET Autoridades Determinantes
 * param {object} params
 * @returns {Promise<object>}
 */
export const getAutoridadesDeterminantes = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Autoridad Determinante
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getAutoridadDeterminante = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Autoridad Determinante
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAutoridadDeterminante = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Autoridad Determinante
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAutoridadDeterminante = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Autoridad Determinante
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteAutoridadDeterminante = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
